import React from 'react';
import { AppButton, Box, Inscription, Preloader, RoundPendingIcon } from '@common-fe/common-fe';

import { WarnModal } from '@/components/elements';

import { useSinglePlanReactivationModal } from './hooks/useSinglePlanReactivationModal';

interface Props {
  onCancel: () => void;
}

const testId = 'SinglePlanReactivationModal';

export const SinglePlanReactivationModal: React.FC<Props> = ({
  onCancel,
}) => {
  const { planName, loading: isLoading, isServerError, setIsServerError, onConfirm } = useSinglePlanReactivationModal();

  return (
    <Box pad={{ horizontal: 'spacing24', vertical: 'spacing24' }} data-testid={testId}>
      <Box align="center" margin={{ bottom: 'spacing12' }} data-testid={`${testId}_icon-container`}>
        <RoundPendingIcon color="warning"/>
      </Box>
      <Box margin={{ bottom: 'spacing24' }}>
        <Inscription
          size="2xl"
          weight="bold"
          color="textBody"
          textAlign="center"
          data-testid={`${testId}_title`}
        >
          {`Reactivate ${planName}?`}
        </Inscription>
      </Box>

      <Box
        direction="row"
        gap="spacing12"
        width="100%"
        data-testid={`${testId}_actions`}
        justify='center'
      >
        <Box width="150px">
          <AppButton
            testId={`${testId}_cancel-button`}
            buttonType="secondary"
            onClick={onCancel}
            width="100%"
            disabled={isLoading}
          >
            Cancel
          </AppButton>
        </Box>
        <Box width="150px">
          <AppButton
            testId={`${testId}_confirm-button`}
            onClick={onConfirm}
            width="100%"
            disabled={isLoading}
          >
            {isLoading ? <Preloader color="white" /> : 'Confirm'}
          </AppButton>
        </Box>
      </Box>
      <WarnModal
        testId="plan-reactivation-server-error-modal"
        visible={isServerError}
        onSetVisible={setIsServerError}
        header="The server encountered an error processing the request"
        helptext={`It doesn't appear to have affected your data, but we cannot save the Plan reactivation with the latest records.\nOur technical staff have been automatically notified and will be looking into this with the utmost urgency.`}
        buttonText="Close"
        onSubmit={onConfirm}
        submitButtonText="Try again"
      />
    </Box>
  );
};
